import { useState } from "react";

import "./PasswordBoxControl.css";

interface IPasswordBoxProps {
    id?: string;
    dataCy?: string;
    value?: string;
    placeholder?: string;
    keyOffset?: number;
    className: string;
    capsLockOnMessage?: string;

    onChange: (value: string) => void;
    onEnterPress: () => void;
}

function PasswordBoxControl(props: Readonly<IPasswordBoxProps>): JSX.Element {
    // IF YOU TOUCH THIS CODE YOU HAVE TO TEST THE LOGIN FOR : PC, MAC, IPhone, Android, Virtual Key Board

    const [password, setPassword] = useState<string>("");
    const [isCapsLockOn, setIsCapsLockOn] = useState<boolean>(false);

    function onKeyDown(e: React.KeyboardEvent): void {
        // IF YOU TOUCH THIS CODE YOU HAVE TO TEST THE LOGIN FOR : PC, MAC, IPhone, Android, Virtual Key Board

        if (e.key === "Enter") {
            props.onEnterPress();
        }

        setIsCapsLockOn(e.getModifierState?.("CapsLock") ?? false);
    }

    function onChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const newPassword: string = e.target.value;

        // IF YOU TOUCH THIS CODE YOU HAVE TO TEST THE LOGIN FOR : PC, MAC, IPhone, Android, Virtual Key Board
        setPassword(newPassword);

        props.onChange(newPassword);
    }

    return (
        <div className="passwordbox">
            <input
                id={props.id}
                data-cy={props.dataCy}
                key={props.id}
                className={props.className}
                placeholder={props.placeholder}
                type="password"
                value={password}
                onKeyDown={e => onKeyDown(e)}
                onChange={e => onChange(e)}
            />
            {props.capsLockOnMessage && isCapsLockOn && (
                <p className="capslockon-message">
                    {props.capsLockOnMessage}
                </p>
            )}
        </div>
    );
}

export { PasswordBoxControl };
